import { ReleaseNotesProduct } from '../types/release-notes/ReleaseNotesProduct';

export const getCurrentProduct = (
	topLevelProducts: ReleaseNotesProduct[],
	productSlug?: string,
	subProductSlug?: string
): ReleaseNotesProduct | null => {
	if (!productSlug) {
		return null;
	}

	const product = topLevelProducts.find((p) => p.slug === productSlug);
	if (!product) {
		return null;
	}

	if (subProductSlug) {
		return product.sub_products?.find((sp) => sp.slug === subProductSlug) || null;
	}

	return product.sub_products?.length === 0 ? product : null;
};
